module.exports = __webpack_public_path__ + "static/media/ic_auth_google.153289e4.svg";